import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Illustration.css';
import Student from '../../Assets/Student.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Illustration = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const fullName = localStorage.getItem('fullName');
    let firstName = fullName ? fullName.split(' ')[0] : '';

    const [activeBox, setActiveBox] = useState('');

    const handleRotationUpdate = (latest) => {
        const angle = latest.rotate % 360;
        if ((angle >= -40 && angle <= 10) || (angle >= 210 && angle <= 240)) {
            setActiveBox('left');
        } else if ((angle >= 280 && angle <= 330) || (angle >= 120 && angle <= 150)) {
            setActiveBox('right');
        } else if (angle >= 180 && angle <= 200) {
            setActiveBox('bottom');
        } else {
            setActiveBox('');
        }
    };

    return (
        <div className="illustration">
            <div className="content-container">
                <div className="text-content">
                    {fullName && <h3 className="text-content-fullname">{t('Welcome back')}, {firstName}</h3>}
                    <h1>{t('MainQuote')}</h1>
                    <p>{t('SubQuote')}</p>
                    <button className="start-learning-btn" onClick={() => navigate('/courses')}>
                        Start Learning Today
                    </button>
                </div>
                <div className="image-content">
                    <div className="animation-container">
                        <div className="circle-image">
                            <link rel="preload" href={Student} as="image" />
                            <img src={Student} alt="Student" className="student-image" />
                        </div>

                        <motion.div
                            className="loader-half loader-top"
                            initial={{ rotate: -22 }}
                            animate={{ rotate: 240 }}
                            transition={{ duration: 5, ease: 'anticipate', repeat: Infinity, repeatType: 'reverse' }}
                            onUpdate={handleRotationUpdate}
                        ></motion.div>

                        <div className={`info-box left-box ${activeBox === 'left' ? 'blue-glass' : ''}`}>
                            <div className='box-profile-container'>
                                <img src='https://cdn-icons-png.flaticon.com/512/4140/4140077.png' alt='inst' />
                                <p> Quality Instructors</p>
                            </div>
                        </div>
                        <div className={`info-box right-box ${activeBox === 'right' ? 'blue-glass' : ''}`}>
                            <div className='box-profile-container'>
                                <img src='https://cdn-icons-png.flaticon.com/512/3135/3135755.png' alt='stud' /> 
                                <p> Industry Ready Professionals</p>
                            </div>
                        </div>
                        <div className={`info-box bottom-box ${activeBox === 'bottom' ? 'blue-glass' : ''}`}>
                            <p>{t('Most Advanced Courses')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Illustration;
